import React, { FC } from 'react'
import SALink from 'components/SALink'
import useQA from 'hooks/useQA'
import styles from '../Polaroid.module.scss'
import classNames from 'classnames'

type PolaroidTitleProps = {
  artworkTitle: string
  artworkCategory: string
  titleLink: string
  onClick?: (ev: React.SyntheticEvent<Record<string, any>>) => void
  shouldOpenNewDesktopPdpTab?: boolean
}

const PolaroidTitle: FC<PolaroidTitleProps> = ({
  artworkTitle,
  artworkCategory,
  titleLink,
  onClick,
  shouldOpenNewDesktopPdpTab,
}) => {
  const { testId } = useQA()

  return (
    <h6 className={styles.artworkTitle} {...testId('artwork-title')}>
      <SALink
        className={classNames(styles.linkTruncateText, styles.textUnderlineOnHover)}
        alt={`${artworkTitle}, ${artworkCategory}`}
        href={titleLink}
        onClick={onClick}
        rel='nofollow'
        title={`View ${artworkTitle} ${artworkCategory}`}
        target={shouldOpenNewDesktopPdpTab ? '_blank' : ''}
        {...testId('artwork-title-link')}
      >
        {`${artworkTitle} ${artworkCategory}`}
      </SALink>
    </h6>
  )
}

export default PolaroidTitle
